import React from 'react';
import { Trophy, Target, Users, Heart } from 'lucide-react';
import { coachData } from '../data/mockData';
import '../styles/about.css';

const AboutSection = () => {
  const values = [
    {
      icon: <Trophy size={28} />,
      title: "Excellence",
      description: "First-class experience translated into world-class coaching"
    },
    {
      icon: <Target size={28} />,
      title: "Precision",
      description: "Technique-focused training for measurable improvement"
    },
    {
      icon: <Users size={28} />,
      title: "Community",
      description: "Building a family of passionate cricketers"
    },
    {
      icon: <Heart size={28} />,
      title: "Passion",
      description: "Love for the game drives everything we do"
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-grid">
          {/* Left Content */}
          <div className="about-content">
            <div className="section-label">
              <span>About the Coach</span>
            </div>
            <h2 className="section-title">
              Meet <span className="text-highlight">{coachData.name}</span>
            </h2>
            <div className="about-description">
              <p>{coachData.bio}</p>
            </div>
            
            <div className="about-details">
              <div className="detail-item">
                <div className="detail-label">Born</div>
                <div className="detail-value">{coachData.born}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Birthplace</div>
                <div className="detail-value">{coachData.birthplace}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Batting Style</div>
                <div className="detail-value">{coachData.battingStyle}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Specialty</div>
                <div className="detail-value">{coachData.specialty}</div>
              </div>
            </div>
          </div>

          {/* Right Values Grid */}
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
